import { disable } from "ol/rotationconstraint";
import "./Editing.css";
import React from "react";
import { DatePicker } from "@progress/kendo-react-dateinputs";
import { NumericTextBox, TextBox } from "@progress/kendo-react-inputs";
import { Input as KendoInput, InputSuffix } from "@progress/kendo-react-inputs";
import { makeArray } from "../../permissionUtils";

export default function Input({ objValue, onChange, index }) {
    const { id, label, type, value, domains, charLimit } = objValue;

    return (
        <div className="attribute-input">
            <label htmlFor={id}>{label}</label>
            <div className="input">
                {domains && (
                    <select
                        id={id}
                        name={id}
                        value={value || ""}
                        onChange={(e) => onChange(e, index)}
                        className="k-dropdownlist k-picker k-picker-md k-rounded-md k-picker-solid">
                        {/* First value is displayed but value is not taken on submit */}
                        <option value="">-- select option --</option>
                        {makeArray(domains.Domain).map((d, index) => {
                            let a = {
                                ...(d.Code === value ? 'selected=""' : ""),
                            };
                            return (
                                <option value={d.Code}>{String(d.DisplayValue)}</option>
                            );
                        })}
                    </select>
                )}
                {!domains &&
                    (type === "date" ? (
                        <DatePicker
                            id={id}
                            // if value is: 0, undefined, false, "", or null it will be coerced to null
                            value={!value ? null : new Date(value)}
                            onChange={(e) => onChange(e, index)}
                        />
                    ) : type === "double" ? (
                        <NumericTextBox
                            id={id}
                            value={value || null}
                            onChange={(e) => onChange(e, index)}
                        />
                    ) : type === "guid" ? (
                        <TextBox
                            id={id}
                            readOnly={true}
                            disabled={true}
                            value={value || ""}
                            onChange={(e) => onChange(e, index)}
                        />
                    ) : type === "string" ? (
                        <TextBox
                            id={id}
                            value={value || ""}
                            onChange={(e) => onChange(e, index)}
                            valid={
                                String(value).length <= charLimit ||
                                charLimit === -1 ||
                                charLimit === undefined
                            }
                            suffix={() =>
                                charLimit !== -1 &&
                                charLimit !== undefined && (
                                    <>
                                        <InputSuffix>
                                            {`${String(value).length}/${charLimit}`}
                                            &nbsp;
                                        </InputSuffix>
                                    </>
                                )
                            }
                        />
                    ) : (
                        <KendoInput
                            id={id}
                            value={value || ""}
                            onChange={(e) => onChange(e, index)}
                        />
                    ))}
            </div>
        </div>
    );
}
